import { AEMPageType } from "@AEM/models/AEMPage.model"
import { AEMNavigation } from "@AEM/models/AEMPage.model"
import { UseQueryResult } from "@tanstack/react-query"
import { useAEMContent } from "./useAEMContent"

export const useAEMNavData = (navType: AEMPageType) => {
	const { data, isLoading, error } = useAEMContent(
		navType
	) as UseQueryResult<AEMNavigation>
	return { data, isLoading, error }
}
